import React, { useState } from 'react';
import { SearchResults } from './components/SearchResults';
import { FilterPanel } from './components/FilterPanel';
import { TopSearchBar } from './components/TopSearchBar';
import { Sidebar } from './components/Sidebar';
import { SearchControls } from './components/SearchControls';
import { PolicyModal } from './components/PolicyModal';
import { PayerModal } from './components/PayerModal';
export function App() {
  const [selectedRowsCount, setSelectedRowsCount] = useState(0);
  const [selectedPolicy, setSelectedPolicy] = useState<any>(null);
  const [isPolicyModalOpen, setIsPolicyModalOpen] = useState(false);
  const [selectedPayer, setSelectedPayer] = useState<any>(null);
  const [isPayerModalOpen, setIsPayerModalOpen] = useState(false);
  const handlePolicySelect = (policy: any) => {
    setSelectedPolicy(policy);
    setIsPolicyModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsPolicyModalOpen(false);
  };
  const handlePayerSelect = (payer: any) => {
    setSelectedPayer(payer);
    setIsPayerModalOpen(true);
  };
  const handleClosePayerModal = () => {
    setIsPayerModalOpen(false);
  };
  return <div className="flex flex-col h-screen bg-white" data-id="element-0">
      <div className="flex flex-1 overflow-hidden" data-id="element-1">
        <Sidebar data-id="element-2" />
        <div className="flex flex-col flex-1" data-id="element-3">
          <div className="sticky top-0 z-10" data-id="element-4">
            <TopSearchBar data-id="element-5" />
            <SearchControls selectedRowsCount={selectedRowsCount} data-id="element-6" />
          </div>
          <div className="flex flex-1 overflow-hidden" data-id="element-7">
            <main className="flex-1 overflow-auto relative" data-id="element-8">
              <div className="flex" data-id="element-9">
                <div className="flex-1 pr-[345px]" data-id="element-10">
                  <SearchResults onSelectionChange={setSelectedRowsCount} onPolicySelect={handlePolicySelect} onPayerSelect={handlePayerSelect} data-id="element-11" />
                </div>
                <div className="w-[345px] fixed right-0 top-[122px] bottom-0 z-10" data-id="element-12">
                  <FilterPanel data-id="element-13" />
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>
      <PolicyModal isOpen={isPolicyModalOpen} onClose={handleCloseModal} policy={selectedPolicy} data-id="element-14" />
      <PayerModal isOpen={isPayerModalOpen} onClose={handleClosePayerModal} payer={selectedPayer} data-id="element-15" />
    </div>;
}